import { load } from 'cheerio';
import { useSettingsStore } from '@/store/settings/settingsStore';

export function extractERSCategoryDescription(htmlSource: string): string {
    const $ = load(htmlSource);
    const { settings } = useSettingsStore();
    const isDebug = settings.useDebug;
    let descriptionHtml = '';

    const appendContent = (content: string, source: string) => {
        if (!content) {
            if (isDebug) console.log(`Content from ${source} is empty.`);
            return;
        }
        if (descriptionHtml.includes(content)) {
            if (isDebug) console.log(`Content from ${source} is already included.`);
            return;
        }
        if (isDebug) console.log(`Appending content from: ${source}`);
        descriptionHtml += content;
    };

    // 1. H1 element
    const h1Html = $('h1').html() || '';
    appendContent(h1Html, 'h1');

    // 2. font.category_text (excluding literal "Category:")
    $('font.category_text').each((_, el) => {
        const text = $(el).html()?.trim() || '';
        if (text && text !== 'Category:') appendContent(text, 'fontCategoryText');
    });

    // 3. First .text-area
    const textArea = $('.text-area')
        .map((_, el) => $(el).html()?.trim() || '')
        .get()
        .join('');
    appendContent(textArea, 'textAreaSection');

    // 4. .ers_category_description
    const categoryDesc = $('.ers_category_description')
        .map((_, el) => $(el).html()?.trim() || '')
        .get()
        .join('');
    appendContent(categoryDesc, 'categoryDescription');

    return descriptionHtml;
}
